module.exports = __webpack_public_path__ + "img/logo.45086626.png";